<template>
  <ErrorTemplate
    image="https://storage.googleapis.com/komerce/komerce-v1.0/illust-expired.svg"
    title="Sesi kamu sudah habis!"
    desc="Yuk, login lagi dan lanjutkan aktivitasmu kembali!"
    btn-label="Login"
    @onAction="onAction"
  />
</template>

<script>
import secureLs from '@/libs/secureLs'
import secureCookies from '@/libs/cookies'
import ErrorTemplate from './ErrorTemplate.vue'

export default {
  components: { ErrorTemplate },
  mounted() {
    secureLs.clearItem()
    secureCookies.removeItem('accessToken')
  },
  methods: {
    onAction() {
      secureLs.clearItem()
      secureCookies.removeItem('accessToken')
      this.logoutAuthModule()
      if (window !== window.parent) {
        window.parent.postMessage({ type: 'navigate', route: '/logout' }, '*')
      } else {
        window.location.replace('/login')
      }
    },
    logoutAuthModule() {
      const iframe = document.createElement('iframe')
      iframe.src = `${process.env.VUE_APP_BASE_AUTH_MODULE}/logout`
      iframe.width = '0'
      iframe.height = '0'
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    },
  },
}
</script>
